import { render, staticRenderFns } from "./AddSubscriptions.vue?vue&type=template&id=1584c410"
import script from "./AddSubscriptions.vue?vue&type=script&lang=js"
export * from "./AddSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports